export default new class FAQ {
    constructor() {
        this.handler();
    }

    handler() {
        $("._questions dd").hide().prev().click(function () {
            $(this).parents("._questions").find("dd").not(this).slideUp().prev().removeClass("active");
            $(this).next().not(":visible").slideDown().prev().addClass("active");
        });
    }
}();
